<template>
  <div id="app">
    <el-container v-if="!isLogin">
      <div class="login-container" v-loading="loginLoading">
        <div class="login-title">新民市跨境进口供应链平台</div>
        <!-- <div class="login-title">魅塔创新科技进口系统业务演示</div> -->
        <el-form ref="loginForm" :model="loginData" :rules="loginRules" label-position="left" label-width="80px">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="loginData.username" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input @keyup.enter.native="submitLogin" type="password" v-model="loginData.password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-button class="login-button" type="primary" @click="submitLogin">登录</el-button>
        </el-form>
      </div>
    </el-container>
    <el-container v-if="isLogin">
      <el-header height="60px"><Header></Header></el-header>
      <el-container>
        <el-aside :width="controlAside.elAsideWidth">
          <Aside @toggleAside="toggleAside"></Aside>
        </el-aside>
        <el-main :style="controlAside.elMainWidth">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from '@/components/frame/Header.vue'
import Aside from '@/components/frame/Aside.vue'
const md5 = require('@/../static/plugins/md5.js')

export default {
  name: 'App',
  components: {Header, Aside},
  data () {
    return {
      isLogin: false,
      loginData: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'change' }],
        password: [{ required: true, message: '请输入密码', trigger: 'change' }]
      },
      loginLoading: false,
      controlAside: {
        elAsideWidth: '200px',
        elMainWidth: 'width: calc(100% - 200px); left: 200px;'
      }
    }
  },
  methods: {
    /**
     * 收展侧边栏
     */
    toggleAside: function (controlCollapse) {
      var that = this
      var currentWidth = controlCollapse ? '65px' : '200px'
      that.controlAside = {
        elAsideWidth: currentWidth,
        elMainWidth: 'width: calc(100% - ' + currentWidth + '); left: ' + currentWidth
      }
    },
    /**
     * 登录
     */
    submitLogin () {
      let that = this
      // that.loginLoading = true
      let loginData = that.loginData
      that.$refs['loginForm'].validate(valid => {
        if (!valid) return ''
        // that.loginLoading = false
        that.SERVER.request({
          url: 'admin.php',
          method: 'POST',
          data: {
            controller: 'login',
            data: {
              username: loginData.username,
              password: md5.hexMD5(loginData.password)
            }
          },
          success: function (res) {
            console.log(res)
            if (res.data.status === 200) {
              // that.COOKIE.setCookie('uid', res.data.data, 7)
              that.COOKIE.setCookie('uid', res.data.data._id)
              that.COOKIE.setCookie('username', loginData.username)
              that.COOKIE.setCookie('utoken', res.data.data.token)
              that.isLogin = true
            } else {
              that.$message.error(res.data.errmsg)
              that.loginLoading = false
            }
          },
          error: function (errMsg) {
            that.boundErrorMessages(errMsg)
          }
        })
      })
    },
    /**
     * 验证 uid
     */
    verifyLogin () {
      let that = this
      let uid = that.COOKIE.getCookie('uid')
      let utoken = that.COOKIE.getCookie('utoken')
      console.log('utoken', utoken)
      console.log('uid', uid)
      if (uid !== '') {
        that.isLogin = true
      } else {
        that.isLogin = false
      }
    }
  },
  mounted () {
    this.verifyLogin()
  }
}
</script>

<style scoped>
.el-container {
  width: 100%;
}
/* 页面主体样式 */
.el-header {
  background-color: #363636;
  border-bottom: 2px solid #494949;
  box-shadow: 0px 0px 10px #707070;
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.el-aside {
  background: #f1f1f1;
  height: calc(100% - 60px);
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  left: 0;
  top: 60px;
  z-index: 10;
}
.el-main {
  background-color: #fff;
  min-height: calc(100% - 60px);
  width: calc(100% - 200px);
  position: absolute;
  left: 200px;
  top: 60px;
  padding: 10px;
  overflow-x: hidden;
  overflow-y: auto;
}
.login-container {
  padding: 35px 50px;
  background-color: #fff;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 20vh;
}
.login-container .el-form {
  width: 350px;
}
.login-title {
  color: #343A40;
  font-size: 25px;
  font-weight: 100;
  letter-spacing: 2px;
  margin-bottom: 40px;
  width: 100%;
  text-align: center;
}
.login-button {
  width: 100%;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue